module.exports = __webpack_public_path__ + "static/media/informaion-img.b4038512.png";